module.exports = __webpack_public_path__ + "img/jianianhua_img3.a20dfa19.jpg";